import { SESSION } from "@/config/session";

export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const WHATSAPP_GROUP_LINK = process.env.REACT_APP_WHATSAPP_GROUP_LINK || "#";
export const EVENT_START = SESSION.startISO;

// Paste image URLs (or /images/xyz.jpg placed in /public/images) to replace the placeholder slots
export const IMAGES = {
  hero: "/images/sandeep-portrait.jpg",
  mentor: "/images/sandeep-stage.webp",
  part1: "/images/sandeep-teaching.webp",
  part2: "/images/sandeep-audience.webp",
  final: "/images/sandeep-portrait.jpg",
};

export const GCAL_LINK =
  "https://calendar.google.com/calendar/render?action=TEMPLATE" +
  "&text=" + encodeURIComponent("The Wealth Code Masterclass with Sandeep Gupta") +
  "&dates=" + SESSION.calendarDates +
  "&ctz=Asia/Kolkata" +
  "&details=" + encodeURIComponent("Live on Zoom with Sandeep Gupta. The Zoom link and reminders are shared in the WhatsApp group: " + (process.env.REACT_APP_WHATSAPP_GROUP_LINK || "")) +
  "&location=" + encodeURIComponent("Zoom (link in WhatsApp group)");
